'use strict'

import Axios, { AxiosInstance } from "axios";
import { ProviderNotificationData } from '@/models/notification-data';

export class ProviderMatchService {
  private _api!: AxiosInstance;

  constructor() {
    this._api = Axios.create({
      baseURL: process.env.VUE_APP_ECE_API_URL,
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': 'eaQSPYWOqAbDOpjX3zFC2bDJvh6z7wB3wV888d25'
      }
    });
  }

  async getNotificationData(workflowId: string): Promise< Array<ProviderNotificationData>> {
    const response = await this._api.get<Array<ProviderNotificationData>>(`/NotificationData/${workflowId}?nocache=${new Date().getTime()}`);
    return response.data;
  }
}
